import ArticleLayout from '../../components/HelpCenterComponents/ArticleLayout';
import { PrecticesTroubleshootingContentBody } from '../../components/data/data/HelpCenter/PrecticesTroubleshooting';

const ARTICLE_TITLES = [
  'Best Practices and Troubleshooting',
  'Best Practices',
  'Pitfalls to Avoid',
];

const TOC_DATA = {
  0: ['Best Practices and Troubleshooting'],
  1: ['Best Practices'],
  2: ['Pitfalls to Avoid'],
};

const PracticesTroubleshootingArticles = () => {
  return (
    <ArticleLayout
      articleTitles={ARTICLE_TITLES}
      tocData={TOC_DATA}
      ContentBodyComponent={PrecticesTroubleshootingContentBody}
      sectionName="PrecticesTroubleshooting"
      searchPlaceholder="Search Partnership documentation"
      showUseCases={true}
      showTitle={false}
    />
  );
};

export default PracticesTroubleshootingArticles;
